import { ListСertificates } from './ListCertificates'



export const Component = { ListСertificates }